export default "__VITE_ASSET__312fa800__"